/**
 * Created by Julio Perez on 9/20/2016.
 */

import * as path from '../../shared/js/ga-tracking-path';

export default class NavLinksStripController{
    constructor(
        $state,
        navLinksStripService
    ){

        let vm = this;
        vm.subHeaderSection = 'Net Wealth Segments, $USD';
        vm.subHeaderToggle = 'Year';

        vm.navLinksStripService = navLinksStripService;
        // vm.mapLeafletService = mapLeafletService;

        vm.navLinks = vm.navLinksStripService.getSectionData();
        vm.toggles = [
            { "name": "Current",
                "year": "2016"
            },
            { "name": "Forecast",
                "year": "2030"
            }
        ]

        vm.sectionSelected = $state.params.section;
        vm.toggleSelected = $state.params.toggle;

        // vm.relatedContent = vm.navLinksStripService.relatedContent;


        if(vm.sectionSelected == null){
            vm.sectionSelected = vm.navLinksStripService.getContentNameByID(0).name;
            $state.params.city = vm.sectionSelected;
        }

        if(vm.toggleSelected == null){
            vm.toggleSelected = "Current";
            $state.params.city = vm.toggleSelected;
        }

        vm.changeSelection = (section) =>{

            vm.sectionSelected = section;

            vm.trackChange(section);

            $state.go('appView.headerSection', {section: section, toggle: vm.toggleSelected}, {notify: false});
            $state.params.section = section;
        };

        vm.changeToggle= (toggle) =>{

            vm.toggleSelected = toggle;

            vm.trackChange(toggle);

            $state.go('appView.headerSection', {section: vm.sectionSelected, toggle: toggle}, {notify: false});
            $state.params.section = toggle;
        };


        vm.trackChange=(selection)=>{

             if(path.isTracking){
                ga('send', {
                    hitType: 'event',
                    eventCategory: 'VisApps',
                    eventLabel: path.emiENV,
                    eventAction: path.emiENV + '-clicked-' + selection
                });


                ga('send', {
                    hitType: 'screenview',
                    appName: path.emiENV,
                    screenName: path.emiENV + '-clicked-' + selection
                });
            }else{
                console.log("TEST: ",path.emiENV + '-clicked-' + selection);
            }
        }

    }


}

NavLinksStripController.$inject =[
    '$state',
    'navLinksStripService'
];


// WEBPACK FOOTER //
// ./src/app/ui/nav-links-strip/nav-links-strip.controller.js